// test1007
(1007 && 0);
